export default "__VITE_ASSET__7SC6MIYK__"